import React from 'react';
import { FadeIn } from './FadeIn';
export function HookSection() {
  return <section className="bg-brand-cream py-20 px-6" data-id="element-111">
      <div className="max-w-3xl mx-auto" data-id="element-112">
        <FadeIn data-id="element-113">
          <p className="text-xl md:text-2xl leading-relaxed italic text-brand-gray mb-8 font-serif" data-id="element-114">
            "You walk into the living room and see it again. The glazed eyes.
            The endless thumb-flick. The glowing screen that seems to be sucking
            the ambition right out of your teenager."
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-115">
          <p className="text-lg md:text-xl leading-relaxed text-brand-gray" data-id="element-116">
            To you, it's a waste of time. But to the modern economy, your teen
            is sitting on a{' '}
            <strong className="text-brand-navy font-bold" data-id="element-117">
              goldmine of undocumented skills
            </strong>{' '}
            that local business owners are desperate to pay for.
          </p>
        </FadeIn>
      </div>
    </section>;
}